import angular from 'angular';
import animate from 'angular-animate';
import cookies from 'angular-cookies';
import messages from 'angular-messages';

import sfCtrl from './_sf-ctrl';
import sfCtrl2 from './_sf-ctrl-2';
import nfyCtrl from './_nfy-ctrl';

angular
  .module('volusionForms', [
    animate,
    cookies,
    messages
  ])
  .config(['$provide', ($provide) => {
    $provide.decorator('$browser', ['$delegate', ($delegate) => {
      $delegate.onUrlChange = () => {};
      $delegate.url = () => '';
      return $delegate;
    }]);
  }])
  .controller('sfCtrl', sfCtrl)
  .controller('sfCtrlTwo', sfCtrl2)
  .controller('nfyCtrl', nfyCtrl);
